import { createRequestTypes } from 'common/websocket-redux';

export const GET_HEALTH_SOLUTION_CATEGORY =
  'parentCategoryPage/GET_HEALTH_SOLUTION_CATEGORY';
export const REQUEST_GET_HEALTH_SOLUTION_CATEGORY = createRequestTypes(
  'parentCategoryPage/REQUEST_GET_HEALTH_SOLUTION_CATEGORY',
);
